import Badge from '@mui/material/Badge';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import { Loader } from 'packages/workspace/design/widgets/ui/Loader';
import useInternalChatChannels, { useFetchChannelConversation } from 'packages/workspace/modules/datastores/internal-chat/useInternalChatChannels';
import type { InternalChatConversation } from 'packages/workspace/services/models/internal-channel';
import useInternalConversationStore, { InternalConversationStore } from 'packages/workspace/services/store/omnichannel/internal-conversation-store';
import { createElement, useState } from 'react';
import * as MaterialDesign from 'react-icons/md';

export const ChannelsContainer: React.FC = () => {
  const [active_conversation, setActiveConversation] = useState<string>('');

  const channelsQuery = useInternalChatChannels();
  const conversationMessagesQuery = useFetchChannelConversation(active_conversation);

  const internalConvState = useInternalConversationStore();
  /**
   * Active conversation.
   * @param conversation_id
   */
  const makeConversationActive = (conversation_id: string) => {
    setActiveConversation(conversation_id);
    InternalConversationStore.setActiveWindow(conversation_id);
    let msgsCount = internalConvState.ongoing_messages?.[conversation_id]?.filter((eachMessage) => eachMessage.isread === false)?.length ?? 0;
    if (msgsCount > 0) {
      InternalConversationStore.updateUnreadMessagesToZero(msgsCount, true);
    }
  };

  return (
    <div>
      <List
        className="rhs-list rhs-channel-list"
        component="nav"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            Channels
          </ListSubheader>
        }
      >
        {channelsQuery.isLoading ? (
          <span>Loading ...</span>
        ) : (
          <>
            {channelsQuery?.data?.map((channel: InternalChatConversation) => (
              <ListItem
                className={channel.conversation_id === internalConvState.active_window?.conversation_id ? 'bg-tc-6' : ''}
                key={channel.conversation_id}
                button
                onClick={() => makeConversationActive(channel.conversation_id)}
              >
                {channel.components.icon && (
                  <ListItemIcon>
                    {createElement(MaterialDesign[channel.components.icon], { className: 'text-lg text-tc-5 border border-tc-5 w-6 h-6 rounded-2xl py-1 cursor-pointer badge-design mr-2' })}
                  </ListItemIcon>
                )}

                <ListItemText primary={channel.display_name} secondary={channel.last_message} />
                <Badge
                  className="mr-6 badge-design"
                  badgeContent={internalConvState.ongoing_messages?.[channel.conversation_id]?.filter((eachMessage) => eachMessage.isread === false)?.length ?? 0}
                  max={9}
                />
              </ListItem>
            ))}
          </>
        )}
      </List>
      {conversationMessagesQuery.isLoading && <Loader />}
    </div>
  );
};
